import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const PoweredByContainer = styled.div`
  width: 1200px;
  gap: 12px;
  border-radius: 16px;
  padding: 20px 16px;
  font-weight: 400;
  font-size: 16px;
  margin: 0 auto;
  background: ${theme.whiteText};
`;
